module.exports = __webpack_public_path__ + "img/Code.d99b99fc.svg";